import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';
import './ResetPassword.css';
import Billede1 from '../../Images/Billede1.jpg';
import HeroSection from '../../components/HeroSection';

const ResetPassword: React.FC = () => {
    const location = useLocation();
    const navigate = useNavigate();

    const [token, setToken] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const [successMessage, setSuccessMessage] = useState('');

    // ✅ Browser already decodes URL safely
    useEffect(() => {
        const query = new URLSearchParams(location.search);
        const t = query.get('token');
        if (t) setToken(t);
    }, [location]);

    const handleResetPassword = async (e: React.FormEvent) => {
        e.preventDefault();
        setErrorMessage('');
        setSuccessMessage('');

        if (!newPassword || !confirmPassword)
            return setErrorMessage('Please enter all fields.');

        if (newPassword !== confirmPassword)
            return setErrorMessage('Passwords do not match.');

        try {
            await axios.post(
                `${process.env.REACT_APP_API_URL}/api/auth/reset-password`,
                { token, newPassword }
            );

            setSuccessMessage('Password reset successfully! Redirecting...');
            setTimeout(() => navigate('/login'), 2000);
        } catch (err: any) {
            setErrorMessage(
                err.response?.data?.Message ||
                'Failed to reset password.'
            );
        }
    };

    return (
        <div className="home">
            <HeroSection
                titleEn="Welcome to Badminton Denmark"
                titleDa="Velkommen til Badminton Danmark"
                descriptionEn="Login or sign up to access all the features!"
                descriptionDa="Log ind eller opret en profil for at få adgang til alle funktioner!"
                imageSrc={Billede1}
            />
            <div className="reset-password-page">
                <h2>Reset Password</h2>

                <form onSubmit={handleResetPassword} className="reset-password-form">
                    <input
                        type="password"
                        placeholder="New password"
                        value={newPassword}
                        onChange={e => setNewPassword(e.target.value)}
                        required
                    />

                    <input
                        type="password"
                        placeholder="Confirm password"
                        value={confirmPassword}
                        onChange={e => setConfirmPassword(e.target.value)}
                        required
                    />

                    <button type="submit">Reset Password</button>

                    {errorMessage && <p className="error">{errorMessage}</p>}
                    {successMessage && <p className="success">{successMessage}</p>}
                </form>
            </div>
        </div>
    );
};

export default ResetPassword;